<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Log Aktivitas Pengguna"
        class="card-wrapper"
        >
        <form >
          <esign-filter-panel>
          <div style="height: 80px" class="form-input row">
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Username/Nama</p>
              <v-text-field
                v-model="searchForm.username"
                placeholder="Cari berdasarkan Username/Nama"
                dense
                outlined
              />
            </div>
            <v-col
              cols="12"
              sm="6"
              md="3"
            >
              <v-menu
                v-model="tanggalAwal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <p class="label font-weight-bold mb-1">Tanggal Awal</p>
                  <v-text-field
                    outlined
                    dense
                    clearable
                    v-model="searchForm.startdate"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="searchForm.startdate"
                  @input="tanggalAwal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
            >
              <v-menu
                v-model="tanggalAkhir"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <p class="label font-weight-bold mb-1">Tanggal Akhir</p>
                  <v-text-field
                    outlined
                    dense
                    clearable
                    v-model="searchForm.enddate"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="searchForm.enddate"
                  @input="tanggalAkhir = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <div class="col-2">
              <p class="label font-weight-bold mb-1"><br></p>
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="searchPengguna()"
              >
                Cari
              </v-btn>
            </div>
          </div>
          </esign-filter-panel>
          <br>
        </form>
        <v-card>    
        <v-data-table
            :headers="headers"
            :items="logaktivitas"
            :loading="isLoading"
            no-data-text="Data Log Aktivitas Pengguna tidak ditemukan"
            no-results-text="Data Log Aktivitas Pengguna tidak ditemukan"
            loading-text="Memuat data..."
            :options.sync="options"
            :server-items-length="totalData"
            hide-default-footer
            disable-sort
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            :items-per-page-options="[10, 20, 50]"
            @update:options="on['update:options']"
            />
          </template>
        <!-- This template looks for headers with formatters and executes them -->
        <template
            v-for="header in headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ header, value }"
          >
            {{ header.formatter(value) }}
        </template>
        <template v-slot:item.status="{ item }">
            {{ item.status == true ? "Aktif" : "Tidak Aktif" }}
          </template>
          <template v-slot:item.aksi="{ item }">
            <v-btn class="mx-1 mt-1 mb-1" x-small color="primary" dark @click="detailItem(item)"><v-icon small class="mr-1"> mdi-eye </v-icon>Detail</v-btn>
          </template>
        </v-data-table>
        </v-card>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Tutup</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";
import moment from "moment";

export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["searchForm", "appliedSearch", "nomor_halaman", "totalData", "options"],
  onListStateRestored() {
    // keep the restored page instead of jumping back to page 1
    this.getDataSource = ""
  },
  data () {
    return {
      dateFormat: "DD-MM-YYYY HH:mm:ss",
      logaktivitas: [],
      initial: true,
      isLoading: true,
      totalData: 0,
      startdate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      enddate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      tanggalAwal: false,
      tanggalAkhir: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      nomor_halaman: 1,
      getDataSource: "search",
      options: {},
      // filters applied with "Cari"; paging always uses these, never half-edited form values
      appliedSearch: null,
      headers: [
        {
          text: 'Username',
          align: 'start',
          sortable: false,
          value: 'username',
        },
        { text: 'Peran', 
          sortable: false,
          value: 'peran' 
        },
        { text: 'Waktu', 
          sortable: true,
          value: 'waktu', 
          formatter: (x) => (x ? moment.utc(x).locale("id").format(this.dateFormat) : null),
        },
        { text: 'Aktivitas', 
          sortable: false,
          value: 'aktivitas' 
        },
        { text: 'IP Address', 
          sortable: false,
          value: 'ipaddress' 
        },
        { text: 'Aksi',
          sortable: false,
          value: 'aksi' },
      ],      
      searchForm: {
        username: "",
        startdate: "",
        enddate: "",
      }
    }
  },
  components: {
  },
  watch: {
    options: {
      handler(val, old) {
        const page = (val && val.page) || 1
        const sizeChanged = !!old && old.itemsPerPage !== undefined && val.itemsPerPage !== old.itemsPerPage
        if (page !== this.nomor_halaman || sizeChanged) {
          this.nomor_halaman = page
          this.getDataSource = ""
          this.getData()
        }
      },
      deep: true
    },
  },
  created() {
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    console.log("loading")
    this.initial = !this.listStateRestored
    this.getData()
    console.log("tes moment")
    console.log(moment.locale())
  },
//   computed: {
//       filteredPengguna(){
//           return this.logaktivitas.filter(item => item.status)
//       }
//   },
  methods: {
    getData() {
      this.isLoading = true;
      console.log(this.isLoading);
      console.log("form data:");
      if(this.initial) {
        this.resetForm()
      }
      if (this.searchForm.startdate === null) {
        this.searchForm.startdate = ""
      }
      if (this.searchForm.enddate === null) {
        this.searchForm.enddate = ""
      }
      if (!this.appliedSearch) {
        this.appliedSearch = JSON.parse(JSON.stringify(this.searchForm))
      }
      const f = this.appliedSearch
      if (this.getDataSource == "search") {
        this.totalData = 0
      }
      console.log(this.searchForm);
      apiServer
        .get("/log_aktivitas/all", {
          params: {
              username: f.username,
              startdate: f.startdate,
              enddate: f.enddate,
              nomor_halaman: this.nomor_halaman,
              ukuran_halaman: this.options.itemsPerPage || 10,
              total_data: this.totalData,
            }})
        .then(response => {
          console.log("responded" + response.data.data);
          this.logaktivitas = response.data.data;
          console.log(response.data.data)
          this.isLoading = false;
          this.initial = false;
          this.totalData = response.data.total
          this.getDataSource = ""
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
          this.showSnackbar("red", error.response.data.message)
        });
    },
    searchPengguna() {
      if (this.searchForm.startdate === null) this.searchForm.startdate = ""
      if (this.searchForm.enddate === null) this.searchForm.enddate = ""
      this.appliedSearch = JSON.parse(JSON.stringify(this.searchForm))
      this.getDataSource = "search"
      this.nomor_halaman = 1
      if (this.options.page && this.options.page !== 1) {
        this.options = Object.assign({}, this.options, { page: 1 })
      }
      this.getData()
    },
    detailItem(item){
      this.$router.push('/log-aktivitas/detail/' + item.id);
    },
    resetForm(){
      this.searchForm.username = ""
      this.searchForm.startdate = ""
      this.searchForm.enddate = ""
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
  }
}
</script>
<style>
  .pagination li a {
    padding: 0px 10px!important;
    border:none;
  }

  .pagination li.active a {
    background-color: #ffffff;
    color: #000;
}
</style>